module.exports = __webpack_public_path__ + "img/b018b822ccc3375fd36f0bf0299f6e49.png";